import * as Sentry from '@sentry/react';

const { PROD, VITE_APP_GATEWAY_BASE_URL, VITE_APP_ERROR_TRACKER_DSN, MODE } = import.meta.env;

export const ErrorTracker = (options?: Sentry.BrowserOptions) => {
  Sentry.init({
    dsn: VITE_APP_ERROR_TRACKER_DSN,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    environment: MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
        blockAllMedia: false,
        networkCaptureBodies: true,
        networkDetailAllowUrls: [window.location.origin, VITE_APP_GATEWAY_BASE_URL],
      }),
      Sentry.feedbackIntegration({
        colorScheme: 'system',
        isEmailRequired: true,
        autoInject: false,
        showBranding: false,
      }),
    ],

    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [window.location.origin, VITE_APP_GATEWAY_BASE_URL],
    // Session Replay
    replaysSessionSampleRate: PROD ? 0.5 : 1.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

    beforeBreadcrumb(breadcrumb, hint) {
      if (breadcrumb.category === 'xhr' && hint?.xhr) {
        // Sentry stores the wrapped XHR under a private key
        const key = Object.keys(hint.xhr).find((k) => /^__sentry_xhr/.test(k));
        const wrapped = key ? hint.xhr[key] : null;
        if (wrapped?.body) {
          // Merge the body into breadcrumb.data so it shows up in Sentry
          return { ...breadcrumb, data: { ...breadcrumb.data, requestBody: wrapped.body } };
        }
      }
      return breadcrumb;
    },

    ...options,
  });
};
